import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import jwtDecode from 'jwt-decode';
import * as utils from '../components/Application/Services/utils';

const STORAGE_KEY = 'angle-store-key';

function getInitialState() {
  const localStorageOnInit = JSON.parse(localStorage.getItem(STORAGE_KEY));
  const token = utils.getUserFromToken();
  const user = localStorageOnInit && localStorageOnInit.user ? localStorageOnInit.user : {};

  if ((localStorageOnInit && localStorageOnInit.user != null) || token) {
    return {
      user: { ...user, ...token },
      loggedIn: !!token,
    };
  }
  return {
    user: '',
    loggedIn: null,
  };
}

const useAuthStore = create(
  persist(
    (set, get) => ({
      ...getInitialState(),

      login: async (data) => {
        // data should contain { user, token, refreshToken }
        set({
          user: { ...data.user, ...jwtDecode(data.token) },
          loggedIn: true,
        });
        localStorage.setItem('token', data.token);
        localStorage.setItem('refreshToken', data.refreshToken);
      },

      setUserData: (data) => {
        set({
          user: { ...data.user, ...jwtDecode(data.token) },
          loggedIn: true,
        });
      },

      setUserDataSettings: (data) => {
        set((state) => ({
          user: { ...state.user, ...data },
        }));
      },

      resetUserData: () => {
        set({
          user: null,
          loggedIn: false,
        });
      },

      logout: async () => {
        await localStorage.clear();
        get().resetUserData();
      },
    }),
    {
      name: 'auth-storage', // Key for Zustand's localStorage persistence
    }
  )
);

export default useAuthStore;
